"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styledDynamic = exports.mergeDynamicCss = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var internal = Symbol["for"]('sxs.internal');
var mergeDynamicCss = function mergeDynamicCss(css1, css2) {
  if (!css1) {
    return css2;
  }
  return function (props) {
    return _objectSpread(_objectSpread({}, css1(props)), css2(props));
  };
};
exports.mergeDynamicCss = mergeDynamicCss;
var styledDynamic = function styledDynamic(cssComponent, dynamicCss) {
  var DefaultType = cssComponent[internal].type;
  var styledComponent = /*#__PURE__*/_react["default"].forwardRef(function (args, ref) {
    var Type = args && args.as || DefaultType;
    var cssProps = args.cssProps || {};
    var styledCss = dynamicCss(_objectSpread(_objectSpread({}, args), {}, {
      cssProps: cssProps
    }));
    var mergedCss = _objectSpread(_objectSpread({}, styledCss), args.css);
    var mergedProps = _objectSpread(_objectSpread({}, args), {}, {
      css: mergedCss
    });
    var _cssComponent = cssComponent(mergedProps),
      forwardProps = _cssComponent.props,
      deferredInjector = _cssComponent.deferredInjector;
    delete forwardProps.as;
    delete forwardProps.cssProps;
    forwardProps.ref = ref;
    if (deferredInjector) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Type, forwardProps), /*#__PURE__*/_react["default"].createElement(deferredInjector, null));
    }
    return /*#__PURE__*/_react["default"].createElement(Type, forwardProps);
  });
  var toString = function toString() {
    return cssComponent.selector;
  };
  styledComponent.className = cssComponent.className;
  styledComponent.displayName = "Styled.".concat(DefaultType.displayName || DefaultType.name || DefaultType);
  styledComponent.selector = cssComponent.selector;
  styledComponent.toString = toString;
  styledComponent[internal] = cssComponent[internal];
  styledComponent.dynamicCss = dynamicCss;
  return styledComponent;
};
exports.styledDynamic = styledDynamic;